var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiBedIconMultiColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorPrimary)",
  d: "M14.934 4v2h-12V0h-2v12h2v-2h12v2h2V4h-2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "var(--dlMultiColorSecondary)",
  d: "M4.333 4.667V2C6.467 2 7 3.778 7 4.667H4.333Z"
})));
export default SvgHaidiBedIconMultiColor;